import { ApiMethods } from 'src/services/api/appApi';
import { QAEmbedOutput } from 'src/services/api/appBuilderApi';
import { RefreshSessionTokenResponse } from 'src/services/api/sessionTokensApi';
import { unAuthApi } from 'src/services/api/unauthApi';

// Both endpoints below are the bearer-authed counterparts of the dashboard's
// Cognito-gated GetQAEmbed / /v1/session-tokens/refresh, reached via the
// backend's public QAAgentPublicPath group (no Cognito session — see
// GetQAEmbedForAgent/RefreshQASessionTokenForAgent in
// backend/lib/resources/app_builder/handler/handler.go). They ride the same
// UnAuthAPIName base query as unAuthApi's other endpoints — that skips
// Auth.currentSession() — and carry the run-scoped bearer explicitly as an
// Authorization header instead, since the backend authenticates the run
// itself via that header rather than a Cognito identity.
export const qaHarnessAgentApi = unAuthApi.injectEndpoints({
  endpoints: (build) => ({
    getQAEmbedForAgent: build.query<
      QAEmbedOutput,
      { appId: string; runToken: string }
    >({
      query: ({ appId, runToken }) => ({
        path: `/public/app-builders/${appId}/qa/embed`,
        method: ApiMethods.get,
        options: {
          headers: { Authorization: `Bearer ${runToken}` },
        },
      }),
    }),
    refreshQASessionTokenForAgent: build.mutation<
      RefreshSessionTokenResponse,
      { appId: string; runToken: string; token: string }
    >({
      query: ({ appId, runToken, token }) => ({
        path: `/public/app-builders/${appId}/qa/session-token/refresh`,
        method: ApiMethods.post,
        options: {
          headers: { Authorization: `Bearer ${runToken}` },
          body: { token },
        },
      }),
    }),
  }),
});

export const {
  useGetQAEmbedForAgentQuery,
  useRefreshQASessionTokenForAgentMutation,
} = qaHarnessAgentApi;
